import { createFileRoute } from '@tanstack/react-router';
import { useArcadeStoreState } from '@src/hooks/useArcadeStoreState';
import { AllGiveaways } from '@src/components/giveaway/Giveaways';
import { VStack } from 'ui_2';
import { Route as index_route } from '@routes/index';
import { Page } from '@src/components/layout/Page';

export const Route = createFileRoute('/giveaways/')({
  staticData: { title: 'Giveaway Overview' },
  component: function Component() {
    const { isPuzzleWalletWebview } = useArcadeStoreState();

    return (
      <Page
        title={'Giveaways'}
        showFooter={!isPuzzleWalletWebview}
        backRoute={index_route.to}
      >
        <VStack className={`w-full gap-4 pb-8 `}>
          <AllGiveaways />
        </VStack>
      </Page>
    );
  },
});
